import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, mergeMap, of } from 'rxjs'

export const GetReprocessingGrantEpic: Epic = (action$, _, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.fetchReprocessingGrant.match),
    mergeMap((action) =>
      OrderRepository.getReprocessingGrant(action.payload.orderId).pipe(
        mergeMap((result) => of(order.fetchReprocessingGrantResult({ result }))),
        catchError((error: Error) => {
          console.warn('could not load the reprocessing grant', error)
          return of(order.fetchReprocessingGrantResult({ result: null }))
        })
      )
    )
  )
